import NumberRange from './index.vue'

// console.log("NumberRange", NumberRange)
NumberRange.install = function (Vue) {
  Vue.component(NumberRange.name, NumberRange)
}

export default NumberRange;


// WEBPACK FOOTER //
// ./src/base/number-range/index.js